// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"6de9c6a9","531":"a8cb7ccc","727":"79ec52b9","967":"48b38086"}[chunkId] + ".chunk.js";
};